export default () => '<div class="content">High friction material may need to be added to the bottom of the bays in high seismic zones for PVC roof.</div>';
